exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".bullets {\n  list-style: initial !important;\n  margin-left: 50px;\n}\n\n.noBullets {\n  list-style: none !important\n}\n\n.boardMembers {\n  margin-left: 50px;\n}\n\n.justified {\n  text-align: justify; \n}\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /Users/trevor/src/src-westoaks3/west-oaks/src/app/directors/directors.component.css
// module id = ../../../../../src/app/directors/directors.component.css
// module chunks = main